import React from 'react'
import { Col, Container, Row } from 'reactstrap'
import PostEdit from './PostEdit'

export default function AddPostContainer() {
    return (
        <>
            <Container fluid>
                <Row>
                    <Col sm={12}>
                        <PostEdit />
                    </Col>
                </Row>
            </Container>
        </>
    )
}
